@if (loading) {
  <div class="text-center pt-5">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!loading && displayData) {
  <ngx-simplebar class="mx-n3 px-4 file-manager-content-scroll">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="bg-success-subtle">
            <div class="card-body pb-0 px-4">
              <div class="row align-items-center mb-3">
                <div class="col-auto">
                  <button (click)="goBack()" class="btn btn-secondary">
                    <i class="ri-arrow-left-line align-bottom me-1"></i>Go Back
                  </button>
                </div>
                <div class="col text-center">
                  <h1 class="fw-bold mb-2">Examinee Report</h1>
                  <div class="hstack gap-3 justify-content-center">
                    <div><span class="fw-bold text-decoration-underline">Invitation</span>: {{ displayData.createdAt | date: 'medium' }}</div>
                    <div class="vr"></div>
                    <div><span class="fw-bold text-decoration-underline">Answered</span>: {{ displayData.answeredAt | date: 'medium' }}</div>
                  </div>
                </div>
                <div class="col-auto">
                  <button type="button" (click)="openGenerateNewReportModal()" class="btn btn-info waves-effect waves-light">
                    <i class="ri-add-line align-bottom me-1"></i> Generate New Report
                  </button>
                </div>
              </div>
              <ul class="nav nav-tabs-custom border-bottom-0" role="tablist">
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeTab === 1" (click)="setActiveTab(1)" href="javascript:void(0);">
                    Overview
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [class.active]="activeTab === 2" (click)="setActiveTab(2)" href="javascript:void(0);">
                    Reports
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="card-body p-4">
            <div class="tab-content">
              @if (activeTab === 1) {
                <div class="tab-pane active">
                  <div class="row border-bottom border-soft-dark pb-4 mb-4">
                    <div class="col-12 col-md-4 border-end border-soft-dark">
                      <h4 class="card-title mb-3">Person Details</h4>
                      <div class="table-responsive">
                        <table class="table table-borderless mb-0">
                          <tbody>
                            <tr><th class="ps-0" style="width: 100px;">Full Name:</th><td class="text-muted">{{ displayData.fullName }}</td></tr>
                            @if (displayData.mobile) {
                              <tr><th class="ps-0">Mobile:</th><td class="text-muted">{{ displayData.mobile }}</td></tr>
                            }
                            @if (displayData.email) {
                              <tr><th class="ps-0">E-mail:</th><td class="text-muted">{{ displayData.email }}</td></tr>
                            }
                            @if (displayData.location) {
                              <tr><th class="ps-0">Location:</th><td class="text-muted">{{ displayData.location }}</td></tr>
                            }
                            @if (displayData.age) {
                              <tr><th class="ps-0">Age:</th><td class="text-muted">{{ displayData.age }}</td></tr>
                            }
                            @if (displayData.owner) {
                              <tr><th class="ps-0">Owner:</th><td class="text-muted">{{ displayData.owner }}</td></tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 border-end border-soft-dark">
                      <h4 class="card-title mb-3">Questionnaire Details</h4>
                      <div class="table-responsive">
                        <table class="table table-borderless mb-0">
                          <tbody>
                            <tr><th class="ps-0" style="width: 100px;">Name:</th><td class="text-muted">{{ displayData.questionnaire.name }}</td></tr>
                            <tr><th class="ps-0">Chapters:</th><td class="text-muted">{{ displayData.questionnaire.chapters.length }}</td></tr>
                            <tr><th class="ps-0">Questions:</th><td class="text-muted">{{ displayData.totalQuestions }}</td></tr>
                            <tr><th class="ps-0">Language:</th><td class="text-muted">{{ displayData.language | titlecase }}</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 text-center">
                      <h4 class="card-title mb-3">Final Score</h4>
                      <div class="mt-4">
                        <circle-progress
                          [percent]="displayData.finalScore"
                          [radius]="80"
                          [outerStrokeWidth]="8"
                          [innerStrokeWidth]="0"
                          [outerStrokeColor]="displayData.scoreColor"
                          [animation]="true"
                          [animationDuration]="500"
                          [titleColor]="displayData.scoreColor"
                          [unitsColor]="displayData.scoreColor"
                          [subtitleColor]="'#999'"
                          [subtitle]="'Score'">
                        </circle-progress>
                      </div>
                    </div>
                  </div>
                  <div class="row border-bottom border-soft-dark pb-4 mb-4">
                    <div class="col-lg-12">
                      <app-questionnaire-chapters
                        [viewMode]="true"
                        [chapters]="displayData.questionnaire.chapters"
                        [report]="true">
                      </app-questionnaire-chapters>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 mb-5">
                      <h4 class="card-title mb-3">Stress Statistics</h4>
                      <div style="height: 400px;">
                        <ngx-charts-line-chart
                          [scheme]="colorSchemeLine"
                          [results]="displayData.stressData"
                          [xAxis]="showXAxis"
                          [yAxis]="showYAxis"
                          [legend]="showLegend"
                          [showXAxisLabel]="true"
                          [showYAxisLabel]="true"
                          [xAxisLabel]="'Questions'"
                          [yAxisLabel]="'Stress Level'"
                          [autoScale]="autoScale"
                          [showGridLines]="showGridLines">
                        </ngx-charts-line-chart>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <h4 class="card-title mb-3">Organizational Threshold</h4>
                      <div style="height: 400px;">
                        <ngx-charts-bar-vertical-2d
                          [scheme]="colorSchemeTheme"
                          [results]="displayData.threshData"
                          [xAxis]="showXAxis"
                          [yAxis]="showYAxis"
                          [legend]="showLegend"
                          [showGridLines]="showGridLines"
                          [barPadding]="5"
                          [groupPadding]="10">
                        </ngx-charts-bar-vertical-2d>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (activeTab === 2) {
                <div class="tab-pane active">
                  <app-report-generation [allReports]="examinee.extra_content.reports || []" [entity]="examinee" [page_source]="page_source" [page_data]="page_data" [autoOpenReportId]="targetReportId" (reportOpened)="targetReportId = null" (updateReportsEvent)="handleUpdateReports($event)"></app-report-generation>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </ngx-simplebar>
}

<app-generate-new-report #generateNewReport [page_source]="page_source" [page_data]="page_data" (updateReportsEvent)="handleUpdateReports($event)"></app-generate-new-report>